﻿/* eslint-env Swiftype */

/**
 * Swiftype Filter functionality
 *
 * @class rlListingsBlock
 * @memberOf jQuery.fn
 */
(function ($) {

  $.fn.rlListingsBlock = function () {

    $('.listingblock .result').each(function () {
      if ($(this).find('.details').children('.date').is(':empty')) {
        $(this).find('.details').children('span.readtime').addClass('nodate');
      }
    });

  }
}(jQuery));